import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

var styles = {"container":"niche-js-block-heading-container"};

var propTypes = {
  body: PropTypes.string,
  size: PropTypes.oneOf([2, 3, 4, 5, 6]),
  className: PropTypes.string
};
var defaultProps = {
  body: null,
  size: null,
  className: null
};

// Beware with this one
function Heading(_ref) {
  var body = _ref.body,
    size = _ref.size,
    className = _ref.className;
  var Component = "h".concat(size || 6);
  return /*#__PURE__*/React.createElement(Component, {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)]),
    dangerouslySetInnerHTML: {
      __html: body
    }
  });
}
Heading.propTypes = propTypes;
Heading.defaultProps = defaultProps;

export { Heading as default };
